import Vue from 'vue';

// 阴影及间距
Vue.directive('layout-card', {
    bind: (el, binding, vnode) => {
        const targetFist = (el.firstChild as any);
        const firstClass = targetFist.className || ''; // 看片第一个按钮className;
        let padd = '';
        if (binding.value && binding.value.space) {
            padd = 'keep-card-padding';
        }
        // 设置卡片内的第一个容器的距离卡片的间距
        targetFist.setAttribute('class', firstClass + ' ' + padd);
        el.setAttribute('class', el.className + ' keep-card');
    },
    inserted: (el, binding, vnode) => {
        // ueeueuueu
    },
});

// 外间距
Vue.directive('layout-outer', {
    bind: (el, binding, vnode) => {
        el.style.padding = '0 0.15rem';
    },
    inserted: (el, binding, vnode) => {
        // ueeueuueu
    },
});
